import "./import-global-dependencies";
import "./import-html-templates";
import "./import-mobile-modules";
import "./import-mobile-styles";
import "./import-images";

import "./app/app.react.mobile.bootstrap";
